const PLACEHOLDER = 'https://via.placeholder.com/180x260?text=No+Image'

export default function MovieCard({ movie }) {
  return (
    <div className="movie-card">
      <img
        className="movie-poster"
        src={movie.Poster !== 'N/A' ? movie.Poster : PLACEHOLDER}
        alt={movie.Title}
      />
      <div className="movie-info">
        <div className="movie-title">{movie.Title}</div>
        <div className="movie-year">{movie.Year}</div>
      </div>
    </div>
  )
}